import moment from 'moment';
import { DateType } from 'api/models';
import { ProjectFinancialsDateRange } from 'api/project';
import { numberFormatter } from 'components/atoms/currency-renderer';
import { CalendarEngine } from 'components/organisms/projects-report/common/range-picker/calendar-engine';
import { defaultFormat } from 'utils/date-field/formatter';
import { FinancialsZoomLevel } from '../types/common';

export const hoursToMins = (hours: number): number => hours * 60;

export const minsToHours = (mins: number): number => numberFormatter(mins / 60);

export const percentageRenderer = (value: number | string): string =>
  `${value}%`;

export const getFilteredZoomLevels = (
  zoomLevels: FinancialsZoomLevel[],
  calendarEngine: CalendarEngine,
  startDate?: DateType,
  endDate?: DateType,
): FinancialsZoomLevel[] => {
  if (startDate == null || endDate == null) {
    return [];
  }

  let monthCount = 0;
  let currDate = defaultFormat(
    calendarEngine.toStartOf(moment(startDate), 'month'),
  );

  while (moment(currDate).isSameOrBefore(moment(endDate))) {
    monthCount += 1;
    currDate = defaultFormat(
      calendarEngine.addDuration(moment(currDate), 'month', 1),
    );
  }

  return zoomLevels.filter(
    (zoomLevel) =>
      monthCount >= 6 || zoomLevel !== FinancialsZoomLevel.Quarterly,
  );
};

export const getDateCategoriesBasedOnDuration = (
  { startDate, endDate }: ProjectFinancialsDateRange,
  zoomLevel: FinancialsZoomLevel,
  calendarEngine: CalendarEngine,
): DateType[] => {
  const columns: DateType[] = [];

  if (startDate == null || endDate == null) {
    return [];
  }

  if (zoomLevel === FinancialsZoomLevel.Overall) {
    return [startDate];
  }

  if (zoomLevel === FinancialsZoomLevel.Period) {
    // TODO: handle periodic columns
    return [];
  }

  let currDate =
    zoomLevel === FinancialsZoomLevel.Monthly
      ? defaultFormat(calendarEngine.toStartOf(moment(startDate), 'month'))
      : defaultFormat(calendarEngine.toStartOf(moment(startDate), 'quarter'));

  while (moment(currDate).isSameOrBefore(moment(endDate))) {
    columns.push(currDate);
    currDate = defaultFormat(
      calendarEngine.addDuration(
        moment(currDate),
        zoomLevel === FinancialsZoomLevel.Monthly ? 'month' : 'quarter',
        1,
      ),
    );
  }

  return columns;
};
